<template>
  <div class="ck-page">
    <IconSprite />

    <nav class="ck-nav" aria-label="Main" ref="nav">
      <router-link :to="{ name: 'index' }" class="ck-nav__brand" @click="rescroll({ name: 'index' })">Nikolay <em>Chankov</em></router-link>
      <div class="ck-nav__end">
        <ul class="ck-nav__links">
          <li v-for="item in links" :key="item.label">
            <router-link :to="item.to" class="ck-link" :class="{ 'is-active': active === item.label }" @click="rescroll(item.to)">{{ item.label }}</router-link>
          </li>
        </ul>
        <ThemeToggle />
      </div>
    </nav>

    <main>
      <router-view></router-view>
    </main>

    <footer class="ck-footer">
      <div class="ck-container">
        <div class="ck-footer__row">
          <SocialLinks />
          <a href="#top" class="ck-totop" aria-label="Back to top" @click.prevent="toTop"><CkIcon name="totop" size="lg" /></a>
        </div>
        <p class="ck-footer__copy">© 2023–{{ year }} Nikolay Chankov. All rights reserved.</p>
      </div>
    </footer>
  </div>
</template>

<script>
import IconSprite from '@/components/ui/IconSprite.vue';
import CkIcon from '@/components/ui/CkIcon.vue';
import SocialLinks from '@/components/ui/SocialLinks.vue';
import ThemeToggle from '@/components/ui/ThemeToggle.vue';

export default {
  name: 'App',
  components: { IconSprite, CkIcon, SocialLinks, ThemeToggle },
  data() {
    return {
      links: [
        { label: 'Home', to: { name: 'index' } },
        { label: 'About', to: { name: 'index', hash: '#aboutme' } },
        { label: 'Skills', to: { name: 'index', hash: '#skills' } },
        { label: 'Blog', to: { name: 'blog' } },
        { label: 'Contact', to: { name: 'index', hash: '#contact' } }
      ]
    };
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
    active() {
      const route = this.$route;
      if (route.name === 'index') {
        if (route.hash === '#aboutme') return 'About';
        if (route.hash === '#skills') return 'Skills';
        if (route.hash === '#contact') return 'Contact';
        return 'Home';
      }
      return 'Blog';
    }
  },
  mounted() {
    // The ink field pins under the nav; the nav's height is published as --nav-h for that.
    const nav = this.$refs.nav;
    const set = () => document.documentElement.style.setProperty('--nav-h', nav.offsetHeight + 'px');
    set();
    if (typeof ResizeObserver !== 'undefined') { this.ro = new ResizeObserver(set); this.ro.observe(nav); }
    else window.addEventListener('resize', set);
  },
  unmounted() {
    if (this.ro) this.ro.disconnect();
  },
  methods: {
    toTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    // A link to the address you are already on is no navigation for the router, so scrollBehavior never runs. Home after
    // scrolling down by hand, or About when About is already in the address, would do nothing. Scroll here instead,
    // the same way the router would: to the top, or to the section 72px under the window's top edge.
    rescroll(to) {
      const target = this.$router.resolve(to);
      if (target.fullPath !== this.$route.fullPath) return;
      const el = target.hash && document.querySelector(target.hash);
      if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 72, behavior: 'smooth' });
      else this.toTop();
    }
  }
}
</script>
